/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// import { setCurrentUser } from "../store/actions/authActions.js";
import { Button, Modal } from "flowbite-react";
import { NavLink, useNavigate } from "react-router-dom";
import instance, { fetchEntryDueDate } from "../../api/api";
import { Loader } from "../../components/Loader";

function AdminKickoffPhase() {
  // const [openModal, setOpenModal] = useState(false);
  const [moveRisksModal, setMoveRisksModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dueDate, setDueDate] = useState("");
  const [entryDueDate, setEntryDueDate] = useState(new Date());

  const navigate = useNavigate();
  const [today, setToday] = useState();

  const formatDate = (date) => {
    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchDueDate = async () => {
      const theDueDate = await fetchEntryDueDate();
      setEntryDueDate(theDueDate);
      setToday(formatDate(new Date()));
      setDueDate(formatDate(theDueDate ? theDueDate : new Date()))
    }

    fetchDueDate();
  }, [])

  const handleMoveRisksToNextStage = async () => {
    setIsSubmitting(true);
    try {
      await instance.post(
        `/api/admin/riskDuedate/riskDuedates/create/UNDER_REVIEW`,
        {
          riskStatus: "UNDER_REVIEW",
          dueDate: dueDate ? dueDate : new Date(),
        }
      );
      await instance.post("/api/admin/emails/stage-kickoff ", {
        stageName: "Risk Entry",
        role: "EMPLOYEE",
        riskStatus: "UNDER_REVIEW",
      })
      setIsSubmitting(false);
      navigate("/admin/adminriskregistry")
    } catch (error) {
      setIsSubmitting(false);
      console.error(error);
    }
  };

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Registration
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Kickoff
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <div className="border-2 border-dashed p-6 rounded-lg border-red-300 dark:border-gray-600 h-54 mb-4">
        <div className="space-y-6">
          {/* <h3 className="text-riskRed font-medium text-lg"> {dueDate && dueDate !== today ? "Launched!" : "Ready To Launch"} </h3> */}
          <h3 className="text-riskRed font-medium text-lg">
            Start Risk Registration
          </h3>
          <Button
            onClick={() => setMoveRisksModal(true)}
            className="bg-riskRed font-bold"
          >
            Start
          </Button>
          <Modal
            dismissible
            show={moveRisksModal}
            size="xl"
            onClose={() => setMoveRisksModal(false)}
            popup
          >
            {/* <Modal dismissible show={openModal} onClose={() => setOpenModal(false)}> */}
            <Modal.Header className="ml-3 p-5 border-b">
              <h4 className="font-bold text-gray-700 dark:text-gray-400">
                Ready to launch
              </h4>
            </Modal.Header>
            <Modal.Body>
              <div className="space-y-5 p-3">
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  Are you sure you want to launch entry stage?
                </p>
              </div>
            </Modal.Body>
            <Modal.Footer className="border-t">
              <Button
                color="gray"
                className="border-none text-riskRed"
                onClick={() => setMoveRisksModal(false)}
              >
                Cancel
              </Button>
              <Button
                className="bg-riskRed hover:bg-riskRed"
                onClick={() => {
                  handleMoveRisksToNextStage();
                }}
              >
                {isSubmitting ? <Loader size="sm" /> : "Confirm"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    // user: state.userData.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // setUser: (user) => dispatch(setCurrentUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminKickoffPhase);
